<template>
  <div class="row">
    <div class="col-12">
      <el-dialog
        v-if="isShow()"
        :title="getCalendarName"
        :visible.sync="modals.read"
        width="70%"
        top="2%"
        @open="handleOpen"
      >
        <div class="row">
          <div class="col-12 col-md-8">
            <p style="word-break: auto-phrase">
              {{ $t('common_words.selected_record_info') }}
            </p>
          </div>
          <div class="col-12 col-md-4 text-right">
            <el-tooltip class="item" effect="dark" content="Seleccione un año">
              <el-select
                filterable
                class="select-default mb-4 shadow-sm select-input-text-center ml-2"
                v-model="calendarForm.anio_sel"
                @change="loadCalendar"
              >
                <el-option
                  class="select-default text-center"
                  v-for="(item, index) in anios"
                  :key="index"
                  :label="item.anio"
                  :value="item.anio"
                ></el-option>
              </el-select>
            </el-tooltip>
          </div>
        </div>
        <div
          class="card"
          v-if="rowData && Object.keys(details).length > 0"
          style="border: none"
        >
          <div class="row" v-for="item in 4" :key="item">
            <div
              class="col-xs-12 col-sm-4 col-md-4 text-center mb-4"
              v-for="(m, i) in months[item - 1]"
              :key="i"
            >
              <table class="full-width" cellpadding="3" :align="'center'">
                <tr>
                  <td class="monthtittle text-center">
                    <strong>{{ m }}</strong>
                  </td>
                </tr>
              </table>

              <table
                class="full-width"
                cellpadding="3"
                cellspacing="0"
                :align="'center'"
              >
                <tr>
                  <td class="daytt text-center"></td>
                  <td class="daytt text-center"></td>
                  <td
                    class="daytt text-center"
                    v-for="(day, index) in headers"
                    :key="index"
                  >
                    {{ day }}
                  </td>
                </tr>
              </table>

              <span class="each" v-bind:id="m.toLowerCase() + 'deta'"></span>
            </div>
          </div>
        </div>
        <div v-else class="text-center">
          <p>
            {{ $t('common_words.calendar_no_details') }}
          </p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { Tooltip } from 'element-ui';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Axios } from 'src/class/Axios.js';
import i18n from 'src/i18n';

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  mixins: [MixinPermissions, mixinMasters],
  data() {
    return {
      open: false,
      modals: {
        read: false,
        create: false,
      },
      calendar: null,
      calendarForm: {},
      rowData: {
        id: null,
      },
      anios: [],
      details: [],
      headers: [],
    };
  },

  computed: {
    getCalendarName() {
      if (this.calendar) {
        return this.calendar.name;
      }
      return i18n.t('common_words.no_calendar');
    },
    months() {
      return {
        0: {
          1: i18n.t('months.january'),
          5: i18n.t('months.may'),
          9: i18n.t('months.september'),
        },
        1: {
          2: i18n.t('months.february'),
          6: i18n.t('months.june'),
          10: i18n.t('months.october'),
        },
        2: {
          3: i18n.t('months.march'),
          7: i18n.t('months.july'),
          11: i18n.t('months.november'),
        },
        3: {
          4: i18n.t('months.april'),
          8: i18n.t('months.august'),
          12: i18n.t('months.december'),
        },
      };
    },
  },

  methods: {
    setOpen(status = false) {
      this.modals.read = status;
    },

    handleOpen() {
      if (this.calendar) {
        this.handleView(0, this.calendar);
      }
    },

    handleLoading(loading = false) {
      if (this.showHideLoading()) this.showHideLoading(loading);
      else this.$emit('showHideLoading', loading);
    },

    handleView(_, row) {
      this.handleLoading(true);
      Axios.getMasters('calendars/get_years/' + row.id)
        .then((response) => {
          this.anios = response.data;
          this.rowData = row;
          this.rowData.created_at = moment(
            String(this.rowData.created_at),
            'YYYY-MM-DD HH:mm:ss'
          ).format('YYYY-MM-DD hh:mm:ss');
          this.modals['read'] = true;

          if (this.anios.length > 0) {
            this.calendarForm.anio_sel = this.anios[0].anio;

            Axios.getMasters(
              'calendars/details/' +
                this.rowData.id +
                '/' +
                this.calendarForm.anio_sel
            )
              .then((resp) => {
                this.details = resp.data.calendar_details;
                this.headers = resp.data.headers;
                this.fillCalendar(resp.data.dayEndWeek);
              })
              .catch((error) => {
                this.handleLoading();
                console.log(error);
              });
          }

          this.handleLoading();
        })
        .catch((error) => {
          console.log(error);
          this.handleLoading();
        });
    },

    loadCalendar() {
      this.handleLoading(true);
      Axios.getMasters(
        'calendars/details/' +
          this.rowData.id +
          '/' +
          this.calendarForm.anio_sel
      )
        .then((resp) => {
          this.details = resp.data.calendar_details;
          this.headers = resp.data.headers;
          this.fillCalendar(resp.data.dayEndWeek);
          this.handleLoading();
        })
        .catch((error) => {
          console.log(error);
          this.handleLoading();
        });
    },

    calendarName() {
      this.$nextTick(() => {
        if (this.calendar) {
          this.$emit('calendarName', this.calendar.name);
        }
      });
    },

    fillCalendar(dayEndWeek) {
      this.handleLoading(true);

      let html =
        '<table class="full-width" cellpadding="3" cellspacing="0" align="center">' +
        '<tr>' +
        '<td class="calsec text-center"><strong>#ciclo#</strong></td>' +
        '<td class="dayt text-center" style="background-color:#ci#;color:#ct#">#se#</td> ';

      Object.keys(this.headers).forEach((key) => {
        html +=
          '<td class="dayt text-center ' +
          (key == 'j' || key == 'v' || key == 's' ? 'daysgray' : '') +
          '">#' +
          key +
          '#</td> ';
      });

      html += '</tr></table>';

      let mes = parseInt(this.calendarForm.anio_sel) * 100 + 1;
      let dt = html;
      let semana = 1;
      let i = 0;
      let j = 1;
      let d = '';
      let expr = '';
      let ene = [];
      let feb = [];
      let mar = [];
      let abr = [];
      let may = [];
      let jun = [];
      let jul = [];
      let ago = [];
      let sep = [];
      let oct = [];
      let nov = [];
      let dic = [];
      let nregistros = this.details.length;
      let ultsem = 0;

      this.details.forEach((element) => {
        if (element.year * 100 + element.month > mes) {
          dt = dt.replace('#ciclo#', '');
          dt = dt.replace('#ci#', element.ribbon.color_code);
          dt = dt.replace('#ct#', element.ribbon.color_text);
          dt = dt.replace('#se#', element.week);
          dt = dt.replace('#d#', '');
          dt = dt.replace('#l#', '');
          dt = dt.replace('#ma#', '');
          dt = dt.replace('#mi#', '');
          dt = dt.replace('#j#', '');
          dt = dt.replace('#v#', '');
          dt = dt.replace('#s#', '');

          if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 1)
            ene.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 2)
            feb.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 3)
            mar.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 4)
            abr.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 5)
            may.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 6)
            jun.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 7)
            jul.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 8)
            ago.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 9)
            sep.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 10)
            oct.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 11)
            nov.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 12)
            dic.push(dt);
          mes++;
          dt = html;
        }

        if (element.dayofweek == 1) {
          d = element.day;
          expr = '#l#';
        } else {
          if (element.dayofweek == 2) {
            d = element.day;
            expr = '#ma#';
          } else {
            if (element.dayofweek == 3) {
              d = element.day;
              expr = '#mi#';
            } else {
              if (element.dayofweek == 4) {
                d = element.day;
                expr = '#j#';
              } else {
                if (element.dayofweek == 5) {
                  d = element.day;
                  expr = '#v#';
                } else {
                  if (element.dayofweek == 6) {
                    d = element.day;
                    expr = '#s#';
                  } else {
                    if (element.dayofweek == 0) {
                      d = element.day;
                      expr = '#d#';
                    }
                  }
                }
              }
            }
          }
        }

        dt = dt.replace(expr, d);
        dt = dt.replace('#ci#', element.ribbon.color_code);
        dt = dt.replace('#ct#', element.ribbon.color_text);

        if (j == 1) {
          if (
            semana == 1 ||
            semana == 5 ||
            semana == 9 ||
            semana == 13 ||
            semana == 17 ||
            semana == 21 ||
            semana == 25 ||
            semana == 29 ||
            semana == 33 ||
            semana == 37 ||
            semana == 41 ||
            semana == 45 ||
            semana == 49
          ) {
            dt = dt.replace('#ciclo#', element.cycle);
          }
        } else {
          dt = dt.replace('#ciclo#', '');
        }

        j = 0;

        if (element.dayofweek == dayEndWeek) {
          semana++;
          j = 1;
        }

        semana =
          (ultsem == 52 || ultsem == 53) && element.week == 1
            ? element.week
            : semana;

        if (ultsem == 52 || ultsem == 53) {
          mes = (parseInt(this.calendarForm.anio_sel) + 1) * 100 + 1;
        }

        if (element.week < semana) {
          if (i < nregistros - 1) {
            dt = dt.replace('#ci#', element.ribbon.color_code);
            dt = dt.replace('#ct#', element.ribbon.color_text);
            dt = dt.replace('#se#', element.week);
            dt = dt.replace('#d#', '');
            dt = dt.replace('#l#', '');
            dt = dt.replace('#ma#', '');
            dt = dt.replace('#mi#', '');
            dt = dt.replace('#j#', '');
            dt = dt.replace('#v#', '');
            dt = dt.replace('#s#', '');

            //if ((element.day != new Date(element.year + '-' + (element.month) + '-1').getDay()))
            dt = dt + html;
          }
        }

        ultsem = element.week;
        i++;
      });

      dt = dt.replace('#ciclo#', '');
      dt = dt.replace('#se#', ultsem);
      dt = dt.replace('#d#', '');
      dt = dt.replace('#l#', '');
      dt = dt.replace('#ma#', '');
      dt = dt.replace('#mi#', '');
      dt = dt.replace('#j#', '');
      dt = dt.replace('#v#', '');
      dt = dt.replace('#s#', '');

      dic.push(dt);

      setTimeout(() => {
        document.getElementById('enerodeta').innerHTML = ene;
        document.getElementById('febrerodeta').innerHTML = feb;
        document.getElementById('marzodeta').innerHTML = mar;
        document.getElementById('abrildeta').innerHTML = abr;
        document.getElementById('mayodeta').innerHTML = may;
        document.getElementById('juniodeta').innerHTML = jun;
        document.getElementById('juliodeta').innerHTML = jul;
        document.getElementById('agostodeta').innerHTML = ago;
        document.getElementById('septiembredeta').innerHTML = sep;
        document.getElementById('octubredeta').innerHTML = oct;
        document.getElementById('noviembredeta').innerHTML = nov;
        document.getElementById('diciembredeta').innerHTML = dic;
        this.handleLoading();
      }, 500);
    },
  },

  created() {
    const minOrderTypeList = this.$store.state.auth.user.business.map(
      (empresa) => {
        return empresa.business_types.reduce(
          (accum, curr, index, arr) => {
            if (accum > curr.order) {
              accum = curr.order;
            }
            return accum;
          },
          empresa.business_types.length > 0
            ? empresa.business_types[0].order
            : +Infinity
        );
      }
    );

    const minOrder = Math.min(...minOrderTypeList);
    const minOrderTypeIndex = minOrderTypeList.findIndex(
      (element) => element === minOrder
    );

    if (
      this.$store.state.auth.user.business[minOrderTypeIndex]['calendars']
        .length > 0
    ) {
      this.calendar =
        this.$store.state.auth.user.business[minOrderTypeIndex]['calendars'][0];
      this.calendarName();
    }
  },
};
</script>
